export class DataTypeSampleFormatHelper {
    
    static transform(value: number): string {
        if (value <= 5) return '' + value;
        if (value < 100) return '5+';
        if (value === 100) return '100';
        return String(value).slice(0, -2) + '00+';
	}
}